/** @format */
import { RangeValidationResultState } from '../../../types/baseTypes.js';

export class RangeValidationResult {
    result: RangeValidationResultState;
    minRequired: number;
    maxAllowed: number | null;

    constructor(rangeValidationResultState: RangeValidationResultState, minRequired: number, maxAllowed: number | null) {
        this.result = rangeValidationResultState;
        this.minRequired = minRequired;
        this.maxAllowed = maxAllowed;
    }
}
